import axios from 'axios';
import { getLanguageId } from 'i18n';

export const API_BASE_URL = "https://core.fvv.al/api";

export class BaseApiService {
  constructor(baseURL = API_BASE_URL) {
    if (this.constructor === BaseApiService) {
      throw new TypeError(
        'Abstract class "BaseApi" cannot be instantiated directly.',
      );
    }

    if (!baseURL) {
      throw new TypeError('BaseUrl not provided on BaseApi class');
    }

    this.instance = axios.create({
      baseURL: baseURL,
    });

    this.instance.interceptors.request.use(
      request => {
        request.params = { lang_id: getLanguageId(), ...request.params };
        return request;
      },
      error => error,
    );
    this.instance.interceptors.response.use(this.handleResponse, this.onError);
  }

  handleUnauthorized = () => {
    window.location.reload();
  };

  handleResponse = response => {
    const { data } = response;
    return data;
  };

  onError = ({ response }) => {
    // handling error
    // const response = error.response ? error.response : error;
    // eslint-disable-next-line no-unused-vars
    const { data } = response ?? {};

    if (!data)
      alert(
        `The app is not receiving any response. Please check your internet connection.`,
      );

    const { errors } = data;

    if (errors)
      alert(
        `Something went wrong!\n${Object.values(errors)
          .flatMap(x => {
            return x;
          })
          .join('\n')}`,
      );
    else
      alert(
        `The server did not respond properly. Please contact the administrator of the site.`,
      );

    return { data: null };
  };

  async get(url, filter = null) {
    const queryParams = filter
      ? typeof filter === 'string'
        ? filter
        : typeof filter === 'object'
        ? new URLSearchParams(filter).toString()
        : null
      : null;

    const fullUrl = queryParams ? [url, queryParams].join('?') : url;
    return await this.instance.get(fullUrl);
  }

  async post(url, postData = {}) {
    return await this.instance.post(url, postData);
  }

  async put(url, postData = {}) {
    return await this.instance.put(url, postData);
  }
}
